<section class="content-header">
  <div class="container-fluid">
    <h1>Bildirimler</h1>
  </div>
</section>

<section class="content">
  <div class="container-fluid">
    <div *ngIf="message" class="alert alert-success">{{ message }}</div>
    <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

    <ul class="nav nav-tabs mb-3">
      <li class="nav-item"><a class="nav-link" [class.active]="tab==='send'" href="javascript:void(0)" (click)="setTab('send')">Gönder</a></li>
      <li class="nav-item"><a class="nav-link" [class.active]="tab==='templates'" href="javascript:void(0)" (click)="setTab('templates')">Şablonlar</a></li>
      <li class="nav-item"><a class="nav-link" [class.active]="tab==='intervals'" href="javascript:void(0)" (click)="setTab('intervals')">Aralıklar</a></li>
      <li class="nav-item"><a class="nav-link" [class.active]="tab==='schedules'" href="javascript:void(0)" (click)="setTab('schedules')">Günlük Zamanlama</a></li>
      <li class="nav-item"><a class="nav-link" [class.active]="tab==='config'" href="javascript:void(0)" (click)="setTab('config')">FCM / APNs Ayarları</a></li>
    </ul>

    <!-- SEND -->
    <div class="card" *ngIf="tab==='send'">
      <div class="card-body">
        <div class="form-group">
          <label>Hedef</label>
          <select class="form-control" [(ngModel)]="sendTarget">
            <option value="all">Tüm kullanıcılar</option>
            <option value="user">Tek kullanıcı</option>
          </select>
        </div>
        <div class="form-group" *ngIf="sendTarget==='user'">
          <label>Kullanıcı Id</label>
          <input type="number" class="form-control" [(ngModel)]="send.userId">
        </div>
        <div class="form-group">
          <label>Başlık</label>
          <input class="form-control" [(ngModel)]="send.title">
        </div>
        <div class="form-group">
          <label>Mesaj</label>
          <textarea class="form-control" rows="3" [(ngModel)]="send.body"></textarea>
        </div>
        <div class="form-group">
          <label>Öncelik</label>
          <select class="form-control" [(ngModel)]="send.priority">
            <option [ngValue]="0">Düşük</option>
            <option [ngValue]="1">Normal</option>
            <option [ngValue]="2">Yüksek</option>
          </select>
        </div>
        <button class="btn btn-primary" (click)="doSend()"
          [disabled]="!send.title || !send.body || (sendTarget==='user' && !send.userId)">
          <i class="fas fa-paper-plane"></i> Gönder
        </button>
      </div>
    </div>

    <!-- TEMPLATES -->
    <div *ngIf="tab==='templates'">
      <div class="card">
        <div class="card-header">{{ tpl.id ? 'Şablonu Düzenle' : 'Yeni Şablon' }}</div>
        <div class="card-body">
          <p class="text-muted" ngNonBindable>Değişkenler: <code>{{nickname}}</code>, <code>{{email}}</code>, <code>{{userId}}</code></p>
          <div class="form-group"><label>Ad</label><input class="form-control" [(ngModel)]="tpl.name" [disabled]="!!tpl.id"></div>
          <div class="form-group"><label>Başlık</label><input class="form-control" [(ngModel)]="tpl.title"></div>
          <div class="form-group"><label>Mesaj</label><textarea class="form-control" rows="2" [(ngModel)]="tpl.body"></textarea></div>
          <div class="form-group"><label>Görsel URL</label><input class="form-control" [(ngModel)]="tpl.imageUrl"></div>
          <div class="form-group">
            <label>Öncelik</label>
            <select class="form-control" [(ngModel)]="tpl.priority">
              <option [ngValue]="0">Düşük</option><option [ngValue]="1">Normal</option><option [ngValue]="2">Yüksek</option>
            </select>
          </div>
          <button class="btn btn-primary" (click)="saveTemplate()" [disabled]="!tpl.name || !tpl.title || !tpl.body">Kaydet</button>
          <button class="btn btn-link" *ngIf="tpl.id" (click)="resetTemplate()">Vazgeç</button>
        </div>
      </div>
      <div class="card">
        <div class="card-body table-responsive p-0">
          <table class="table table-hover">
            <thead><tr><th>Ad</th><th>Başlık</th><th>Mesaj</th><th>Öncelik</th><th></th></tr></thead>
            <tbody>
              <tr *ngFor="let t of templates">
                <td>{{ t.name }}</td><td>{{ t.title }}</td><td>{{ t.body }}</td><td>{{ priorityLabel(t.priority) }}</td>
                <td class="text-right">
                  <button class="btn btn-sm btn-outline-primary" (click)="editTemplate(t)">Düzenle</button>
                  <button class="btn btn-sm btn-outline-danger" (click)="deleteTemplate(t)">Sil</button>
                </td>
              </tr>
              <tr *ngIf="templates.length===0"><td colspan="5" class="text-muted">Şablon yok.</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- INTERVALS -->
    <div *ngIf="tab==='intervals'">
      <div class="card">
        <div class="card-header">{{ interval.id ? 'Aralık Ayarını Düzenle' : 'Yeni Aralık Ayarı' }}</div>
        <div class="card-body">
          <div class="form-group"><label>Ad</label><input class="form-control" [(ngModel)]="interval.name"></div>
          <div class="form-row">
            <div class="form-group col-md-6"><label>Min saat</label><input type="number" min="1" class="form-control" [(ngModel)]="interval.minIntervalHours"></div>
            <div class="form-group col-md-6"><label>Max saat</label><input type="number" min="1" class="form-control" [(ngModel)]="interval.maxIntervalHours"></div>
          </div>
          <div class="form-group">
            <label>Şablon</label>
            <select class="form-control" [(ngModel)]="interval.templateId">
              <option [ngValue]="null">— seç —</option>
              <option *ngFor="let t of templates" [ngValue]="t.id">{{ t.name }}</option>
            </select>
          </div>
          <div class="form-check mb-2">
            <input type="checkbox" class="form-check-input" id="qh" [(ngModel)]="interval.quietHoursEnabled">
            <label for="qh" class="form-check-label">Sessiz saatler (UTC)</label>
          </div>
          <div class="form-row" *ngIf="interval.quietHoursEnabled">
            <div class="form-group col-md-6"><label>Başlangıç (HH:mm)</label><input class="form-control" [(ngModel)]="interval.quietHoursStart"></div>
            <div class="form-group col-md-6"><label>Bitiş (HH:mm)</label><input class="form-control" [(ngModel)]="interval.quietHoursEnd"></div>
          </div>
          <button class="btn btn-primary" (click)="saveInterval()"
            [disabled]="!interval.name || interval.minIntervalHours < 1 || interval.maxIntervalHours < interval.minIntervalHours">Kaydet</button>
        </div>
      </div>
      <div class="card">
        <div class="card-body table-responsive p-0">
          <table class="table table-hover">
            <thead><tr><th>Ad</th><th>Aralık</th><th>Şablon</th><th>Sessiz saat</th><th></th></tr></thead>
            <tbody>
              <tr *ngFor="let c of intervals">
                <td>{{ c.name }}</td>
                <td>{{ c.minIntervalHours }}–{{ c.maxIntervalHours }} sa</td>
                <td>{{ c.templateName }}</td>
                <td>{{ c.quietHoursEnabled ? c.quietHoursStart + ' – ' + c.quietHoursEnd : '—' }}</td>
                <td class="text-right">
                  <button class="btn btn-sm btn-outline-primary" (click)="editInterval(c)">Düzenle</button>
                  <button class="btn btn-sm btn-outline-danger" (click)="deleteInterval(c)">Sil</button>
                </td>
              </tr>
              <tr *ngIf="intervals.length===0"><td colspan="5" class="text-muted">Kayıt yok.</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- DAILY SCHEDULES -->
    <div *ngIf="tab==='schedules'">
      <div class="card">
        <div class="card-header">{{ schedule.id ? 'Zamanlamayı Düzenle' : 'Yeni Günlük Zamanlama' }}</div>
        <div class="card-body">
          <p class="text-muted">Saat UTC olarak yorumlanır.</p>
          <div class="form-group"><label>Ad</label><input class="form-control" [(ngModel)]="schedule.name"></div>
          <div class="form-row">
            <div class="form-group col-md-6"><label>Saat (0-23)</label><input type="number" min="0" max="23" class="form-control" [(ngModel)]="schedule.hour"></div>
            <div class="form-group col-md-6"><label>Dakika (0-59)</label><input type="number" min="0" max="59" class="form-control" [(ngModel)]="schedule.minute"></div>
          </div>
          <div class="form-group">
            <label>Şablon</label>
            <select class="form-control" [(ngModel)]="schedule.templateId">
              <option [ngValue]="0">— seç —</option>
              <option *ngFor="let t of templates" [ngValue]="t.id">{{ t.name }}</option>
            </select>
          </div>
          <button class="btn btn-primary" (click)="saveSchedule()" [disabled]="!schedule.name || !schedule.templateId">Kaydet</button>
        </div>
      </div>
      <div class="card">
        <div class="card-body table-responsive p-0">
          <table class="table table-hover">
            <thead><tr><th>Ad</th><th>Saat (UTC)</th><th>Şablon</th><th>Aktif</th><th>Son gönderim</th><th></th></tr></thead>
            <tbody>
              <tr *ngFor="let s of schedules">
                <td>{{ s.name }}</td>
                <td>{{ s.hour | number:'2.0-0' }}:{{ s.minute | number:'2.0-0' }}</td>
                <td>{{ s.templateName }}</td>
                <td><input type="checkbox" [checked]="s.active" (change)="toggleSchedule(s)"></td>
                <td>{{ s.lastFiredAt | date:'short' }}</td>
                <td class="text-right">
                  <button class="btn btn-sm btn-outline-primary" (click)="editSchedule(s)">Düzenle</button>
                  <button class="btn btn-sm btn-outline-danger" (click)="deleteSchedule(s)">Sil</button>
                </td>
              </tr>
              <tr *ngIf="schedules.length===0"><td colspan="6" class="text-muted">Kayıt yok.</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- CONFIG -->
    <div class="card" *ngIf="tab==='config'">
      <div class="card-body">
        <div class="form-group">
          <label>Sağlayıcı</label>
          <select class="form-control" [(ngModel)]="config.provider">
            <option [ngValue]="1">FCM (Android)</option>
            <option [ngValue]="2">APNs (iOS)</option>
          </select>
        </div>
        <ng-container *ngIf="config.provider===2">
          <div class="form-group"><label>Bundle Id</label><input class="form-control" [(ngModel)]="config.bundleId" placeholder="com.linguwa.linguwa"></div>
          <div class="form-group">
            <label>Ortam</label>
            <select class="form-control" [(ngModel)]="config.environment">
              <option value="production">production</option>
              <option value="sandbox">sandbox</option>
            </select>
          </div>
        </ng-container>
        <div class="form-group">
          <label>Credentials JSON</label>
          <textarea class="form-control" rows="8" [(ngModel)]="config.credentialsJson"
            placeholder="FCM: service account JSON. APNs: KeyId, TeamId ve P8PrivateKey alanlı JSON"></textarea>
          <small class="text-muted">Sunucuda şifrelenerek saklanır; kaydedildikten sonra tekrar görüntülenemez.</small>
        </div>
        <button class="btn btn-primary" (click)="saveConfig()" [disabled]="!config.credentialsJson">Kaydet</button>
      </div>
    </div>
  </div>
</section>
